<template>
  <div class="no-disponible-page">
    <div class="container">
      <div class="row justify-content-center align-items-center content-wrapper">
        <div class="col-12 col-md-8 col-lg-6 text-center">
          <div class="card shadow-sm border-0 p-4 p-md-5">
            <div class="mb-4">
              <div class="icon-badge">
                <i class="feather-alert-octagon"></i>
              </div>
            </div>
            <h2 class="fw-bold mb-3 text-dark">Módulo No Disponible</h2>
            <p class="text-muted mb-4 lead fs-6">
              Esta sección no se encuentra disponible actualmente o ha sido trasladada a otro entorno.
            </p>
            <div class="d-flex flex-column flex-sm-row justify-content-center gap-2">
              <router-link to="/" class="btn btn-primary px-4 py-2">
                <i class="feather-home me-2"></i> Ir al Inicio
              </router-link>
              <button type="button" @click="goBack" class="btn btn-outline-secondary px-4 py-2">
                <i class="feather-arrow-left me-2"></i> Regresar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoDisponible",
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push("/");
      }
    },
  },
};
</script>

<style scoped>
.no-disponible-page {
  min-height: 85vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  padding: 2rem 1rem;
}

.content-wrapper {
  min-height: 70vh;
}

.card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);
}

.icon-badge {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  border-radius: 50%;
  background: rgba(220, 53, 69, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-badge i {
  font-size: 38px;
  color: #dc3545;
}

.gap-2 {
  gap: 0.75rem;
}
</style>

